import it from "@/langs/it.json";
import en from "@/langs/en.json";
import store from "@/store";
import { createI18n } from "vue-i18n";

export const i18n = createI18n({
  globalInjection: true,
  legacy: false,
  locale: store.getters["ui/language"],
  messages: { it, en },
  fallbackLocale: "en",
  missingWarn: false,
});

export const switchLanguage = (language: string) => {
  store.commit("ui/setLanguage", language);
  i18n.global.locale.value = language;
};
export default i18n;
